import axios from "../axios";

function getShopCategories() {
  return axios.get("/shop-categories");
}

export {getShopCategories}